export const FLOW = 'FLOW';
export const ACTION = 'ACTION';